import { render, staticRenderFns } from "./PDFPreview.vue?vue&type=template&id=e0d068a6&scoped=true&"
import script from "./PDFPreview.vue?vue&type=script&lang=js&"
export * from "./PDFPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d068a6",
  null
  
)

export default component.exports